import { useState, useEffect } from "react";
import "./manageprint.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";

function Manageprint() {
  const [data, setData] = useState([]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Work Not Start Yet":
        return "red";
      case "Work in Progress":
        return "blue";
      case "Work completed":
        return "green";
      default:
        return "black";
    }
  };

  useEffect(() => {
    Axios.get("http://nodei.ssccglpinnacle.com/getOrder").then((response) => {
      setData(response.data);
    });
  }, []);

  return (
    <div className="manageprint">
      <h5 style={{ textAlign: "center" }}>Manage Printing Status</h5>

      <div style={{ width: "100%", overflowX: "auto", margin: "10px 0" }}>
        <Table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            textAlign: "center",
          }}
        >
          <thead>
            <tr>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Order No
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Vehicle Details
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                PO Date
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Title
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Medium
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                SKU
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Order Quantity
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Total Dispatched Quantity
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Dispatch Quantity
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Balance
              </th>
              <th
                style={{
                  border: "1px solid #ddd",
                  padding: "8px",
                  backgroundColor: "#f2f2f2",
                  fontWeight: "bold",
                  whiteSpace: "nowrap",
                }}
              >
                Order Status
              </th>
            </tr>
          </thead>

          <tbody>
            {data.map((order, orderIndex) =>
              order.updatedQuantity.map((item, itemIndex) => (
                <tr key={`${order.orderid}-${itemIndex}`}>
                  {itemIndex === 0 && (
                    <>
                      <td
                        rowSpan={order.updatedQuantity.length}
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {order.orderid}
                      </td>
                      <td
                        rowSpan={order.updatedQuantity.length}
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {order.vehicle}
                      </td>
                      <td
                        rowSpan={order.updatedQuantity.length}
                        style={{
                          border: "1px solid #ddd",
                          padding: "8px",
                          textAlign: "center",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {new Date(order.ApprovalDate).toLocaleDateString(
                          "en-US",
                          {
                            day: "numeric",
                            month: "long",
                            year: "numeric",
                          }
                        )}
                      </td>
                    </>
                  )}
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      maxWidth: "250px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    title={item.title}
                  >
                    {item.title}
                  </td>

                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.Medium}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.sku}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.approvedquantity}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.DispatchQuantity}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.newQuantity && item.newQuantity.length > 0 ? (
                      item.newQuantity.map((quantityItem, index) => (
                        <span key={index}>{JSON.stringify(quantityItem)} </span>
                      ))
                    ) : (
                      <span>No quantity</span>
                    )}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {item.Balance}
                  </td>
                  <td
                    style={{
                      border: "1px solid #ddd",
                      padding: "8px",
                      textAlign: "center",
                      whiteSpace: "nowrap",
                      color: getStatusColor(item.Currentstatus),
                      fontWeight: "bold",
                    }}
                  >
                    {item.Currentstatus}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>
    </div>
  );
}

export default Manageprint;
